/**
 * @file
 * Behaviors for the Filter Accordion.
 */
/* eslint-disable max-len */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Carousel behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.carousel = {
    attach: function(context) {
      $('.carousel__list')
        .not('.slick-initialized')
        .addClass('.carousel__slick')
        .slick({
          centerMode: true,
          centerPadding: 'calc((100% - 945px) / 2)',
          arrowsPlacement: 'afterSlides',
          appendArrows: $('.carousel__arrows', context),
          prevArrow: $('.carousel__prev', context),
          nextArrow: $('.carousel__next', context),
          dots: false,
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                centerMode: false
              }
            }
          ]
        });
    }
  };
})(document, Drupal, jQuery);
